// extracted by mini-css-extract-plugin
module.exports = {"title":"Faq_title__2qZcz","nav":"Faq_nav__KWaKH","btn":"Faq_btn__KVxOO","active":"Faq_active__AN4Ie","dropdown":"Faq_dropdown__30Nib","list":"Faq_list__xMitA"};